import { Facebook, Linkedin, Twitter, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { getArticleCanonicalUrl, getShareLinks } from "@/hooks/use-articles";

interface ShareButtonsProps {
  slug: string;
  title: string;
}

const ShareButtons = ({ slug, title }: ShareButtonsProps) => {
  // URL canonique pour copier (utilisable directement dans un navigateur)
  const canonicalUrl = getArticleCanonicalUrl(slug);
  // Liens sociaux utilisent l'Edge Function pour les métadonnées OG
  const shareLinks = getShareLinks(slug, title);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(canonicalUrl);
      toast.success("Lien copié !");
    } catch {
      toast.error("Erreur lors de la copie");
    }
  };

  return (
    <div className="flex flex-wrap gap-2 mt-6">
      <Button 
        variant="outline" 
        size="sm" 
        onClick={copyToClipboard}
        className="gap-2"
      >
        <Copy className="w-4 h-4" />
        Copier le lien
      </Button>
      <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer">
        <Button variant="outline" size="sm" className="gap-2">
          <Facebook className="w-4 h-4" />
          Facebook
        </Button>
      </a>
      <a href={shareLinks.linkedin} target="_blank" rel="noopener noreferrer">
        <Button variant="outline" size="sm" className="gap-2">
          <Linkedin className="w-4 h-4" />
          LinkedIn
        </Button>
      </a>
      <a href={shareLinks.twitter} target="_blank" rel="noopener noreferrer">
        <Button variant="outline" size="sm" className="gap-2">
          <Twitter className="w-4 h-4" />
          X (Twitter)
        </Button>
      </a>
    </div>
  );
};

export default ShareButtons;
